import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

export default ['$filter', function ($filter) {
    return function (date, format) {
        var formatted = void 0;
        // This creates a JS date object (ie local date). The angular filter is not concerned with timezone in this invocation so date will remain the same.
        var localDate = LocalDateUtil.toMidnightDate(date);
        if (date) {
            if (!date.hasOwnProperty('year')) {
                console.error('Wrong local date format passed to LocalDateFilter');
            }
            formatted = $filter('date')(localDate, format);
        }
        return formatted;
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/time/LocalDateFilter.js
// module id = 1079
// module chunks = 0